import {
  activeChatbotIdSelector,
  activeFacebookPageIdSelector,
} from '@mm/state/selectors/viewSelectors';
import { BotBuilderRoutes } from '../../../../../../../routes/bot-builder-routes';
import { useHistory } from 'react-router';
import { useSelector } from 'react-redux';
import { useVoyagerCRUDActions } from '@mm/state/actions/VoyagerCRUDActions';
import {
  CreateVoyagerContactsSearchParams,
  VoyagerCreateContactsResponse,
} from '@mm/state/interfaces/voyagerLeads';
import { useModalActions } from '@mm/state/modules/modalsState/actions';

export const useCreateVoyagerLeads = () => {
  const { openCreateMyLeadsAudienceModal } = useModalActions();
  const { createContacts } = useVoyagerCRUDActions();
  const facebookPageId = useSelector(activeFacebookPageIdSelector);
  const chatbotId = useSelector(activeChatbotIdSelector);

  const history = useHistory();

  const onSave = async (
    audienceName: string,
    params: CreateVoyagerContactsSearchParams,
  ) => {
    const res: VoyagerCreateContactsResponse = await createContacts({
      facebookPageId,
      search: { ...params },
      audience: {
        name: audienceName,
      },
    });
    if (res?.audienceId) {
      history.push(
        BotBuilderRoutes.audiences.getLink({
          chatbotId,
          audienceId: res.audienceId,
        }),
      );
    }
  };

  const createVoyagerLeads = (params: CreateVoyagerContactsSearchParams) => {
    openCreateMyLeadsAudienceModal({
      onSave: audienceName => onSave(audienceName, params),
    });
  };

  return { createVoyagerLeads };
};
